import TextOnlyPreview from '../Text/TextOnlyPreview';

type TandCInputPreviewProps = {
  style: any;
  text: string;
  tandcUri: string;
  isChecked: boolean;
  onChecked: () => void;
};
const TandCInputPreview = ({
  style,
  text,
  tandcUri,
  isChecked,
  onChecked,
}: TandCInputPreviewProps) => {
  return (
    <div className="" id="termsAndCondition" style={style}>
      <div className="flex justify-start items-center gap-[8px]">
        <input
          type="checkbox"
          className="mx-1.5 h-4 w-4"
          checked={isChecked}
          onChange={onChecked}
        />
        {tandcUri ? (
          <a
            href={tandcUri}
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer btn-prev underline underline-offset-2"
          >
            <TextOnlyPreview textContent={text} />
          </a>
        ) : (
          <div className="btn-prev">
            <TextOnlyPreview textContent={text} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TandCInputPreview;
